import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { quickPlanPersonSchema, type QuickPlanPersonValues } from '@/features/client-quick-plan';
import { fromDateOnlyString, toDateOnlyString } from '@/shared/lib/utils';

export interface PartnerFormValues {
  partner: QuickPlanPersonValues;
}

const partnerFormSchema = z.object({ partner: quickPlanPersonSchema });

function toFormValues(partner: ConsumerPartner | null): PartnerFormValues {
  return {
    partner: {
      firstName: partner?.firstName ?? '',
      lastName: partner?.lastName ?? '',
      birthDate: partner ? fromDateOnlyString(partner.birthDate) : undefined,
      sex: partner?.sex,
      smokingStatus: partner?.smokingStatus,
      zipCode: partner?.zipCode ?? '',
      maritalStatus: partner?.maritalStatus ?? '',
    } as QuickPlanPersonValues,
  };
}

export function toConsumerPartner({ partner }: PartnerFormValues): ConsumerPartner {
  return {
    firstName: partner.firstName.trim(),
    lastName: partner.lastName.trim(),
    birthDate: toDateOnlyString(partner.birthDate),
    sex: partner.sex,
    smokingStatus: partner.smokingStatus,
    zipCode: partner.zipCode,
    maritalStatus: partner.maritalStatus,
  };
}

/** The partner's details, asked with New Case Quick Start's questions and validation. */
export function usePartnerForm(partner: ConsumerPartner | null) {
  return useForm<PartnerFormValues>({
    resolver: zodResolver(partnerFormSchema),
    mode: 'onTouched',
    defaultValues: toFormValues(partner),
  });
}
